var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Neck/OpenPosition/index.js";
import React from 'react';
import pt from 'prop-types';
import Position from './../../../Fretboard/Neck/Position';
import ViewPort from './../../../Fretboard/Neck/ViewPort';

const OpenPosition = ({
  width,
  tuning
}) => /*#__PURE__*/React.createElement(ViewPort, {
  width: width,
  offset: 0,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 8,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement("foreignObject", {
  width: "100%",
  height: "100%",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 9,
    columnNumber: 5
  }
}, /*#__PURE__*/React.createElement(Position, {
  width: 100,
  pos: 0,
  tuning: tuning,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 10,
    columnNumber: 7
  }
})));

OpenPosition.propTypes = {
  tuning: pt.arrayOf(pt.string).isRequired,
  width: pt.number.isRequired
};
export default OpenPosition;
